import { get, invert } from 'lodash'
import Vue from 'vue'

export default (tabMap) => {
  return {
    data () {
      return {
        initTab: this.$route.params.initTab || tabMap[Object.keys(tabMap)[0]]
      }
    },
    methods: {
      updateHash (value) {
        const tabHash = get(invert(tabMap), value, null)

        if (tabHash) {
          this.$router.replace({...this.$route, hash: tabHash})
        }

        this.initTab = value
      }
    },

    beforeRouteEnter (to, from, next) {
      const initTab = get(tabMap, to.hash, null)
      if (initTab) {
        Vue.set(to.params, 'initTab', initTab)
      }
      next()
    },
  }
}



// WEBPACK FOOTER //
// ./src/mixins/tabRefreshable.js